module.exports = __webpack_public_path__ + "static/media/nikon_video.67902ad5.mov";